
import React, {Fragment} from 'react'
import Component from "./Component";
class LoadingText extends Component
{
    /**
     * [Notes]
     *
     * @param {Object} props
     * @returns void
     */
    constructor(props)
    {
        super(props)

        this.state = {
            ...this.state,
            loadingDots: '.',
            dotsOffset: '..',
            hourglassState: 'start',
        };
    }

    /**
     * [Notes]
     *
     * @returns void
     */
    componentDidMount()
    {
        super.componentDidMount();

        this.loadingInterval = setInterval(this.updateLoadingDots.bind(this), 650);
    }

    updateLoadingDots()
    {
        if (!this._isMounted) {
            window.clearInterval(this.loadingInterval)
            this.loadingInterval = undefined;
            return;
        }

        let {loadingDots, hourglassState} = {...this.state};
        if (loadingDots.length < 3) {
            loadingDots += '.'
        }
        else {
            loadingDots = '.';
        }

        let dotsOffset = '.';
        dotsOffset = dotsOffset.repeat(3 - loadingDots.length);
        if (loadingDots.length === 3) {
            dotsOffset = '';
        }

        switch (hourglassState) {
            case 'start': hourglassState = 'half'; break;
            case 'half': hourglassState = 'end'; break;
            case 'end': hourglassState = 'start'; break;
        }

        this.setState({loadingDots, dotsOffset, hourglassState})
    }

    render()
    {
        let message = this.props.message || 'Loading';

        if (this.props.message
            && this.props.message.includes('.')
            && TB.tryTrans(this.props.message)) {
            message = TB.tryTrans(this.props.message);
        }

        let styles = this.props.style || {};

        if (this.props.adjustOverlay) {
            styles = {
                ...styles,
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 400,
            };
        }

        return (
            <div className="feedback-banner"
                 style={{...styles, color:'rgba(50, 60, 71, 0.4)'}}>
                <i className={`fa fa-hourglass-${this.state.hourglassState}`} style={{fontSize:'35px'}}/>
                <p className="mt-3">
                    {message}{this.state.loadingDots}<span className="invisible">{this.state.dotsOffset}</span>
                </p>
            </div>
        );
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        clearInterval(this.loadingInterval)
    }
}

const LoadingBanner = ({children, isLoading, ...props}) => {

    if (isLoading === false) {
        return (
            <Fragment>
                {children}
            </Fragment>
        )
    }

    return (
        <LoadingText {...props}/>
    );
}

export default LoadingBanner